import React from 'react';
import styled from 'styled-components';

const Custom = styled.input<{ error?: string | null | undefined }>`
  border-radius: 5px;
  height: 45px;
  outline: none;
  border: ${props => (props.error ? '1px solid #ff2d55' : '1px solid #9b9b9b')};
  margin-top: 10px;
  padding: 0px;
`;

const Container = styled.div<{ half?: boolean; dob?: boolean }>`
  font-size: 16px;
  font-weight: 400;
  font-family: 'Red Hat Display', sans-serif;
  display: flex;
  flex-direction: column;
  margin-bottom: 30px;
  margin-right: 30px;
  width: ${props => (props.half ? 'calc(50% - 15px)' : '100%')};

  @media (max-width: 768px) {
    margin-bottom: ${props => (props.dob ? '10px' : '30px')};
  }
`;

const Error = styled.div`
  font-size: 14px;
  font-style: italic;
  color: #ff2d55;
`;

type InputProps = {
  placeholder: string;
  type?: string;
  disabled?: boolean;
  value: string;
  onChange: (value: string) => void;
  defaultValue?: string;
  error: string | undefined | null;
  half?: boolean;
  dob?: boolean;
  maxLength?: number;
  pattern?: '[0-9]*';
  style?: React.CSSProperties;
  autoComplete?: string;
};

const CusInput = React.forwardRef<HTMLInputElement, InputProps>((props, ref) => (
  <Container half={props.half} dob={props.dob}>
    {props.placeholder}
    <Custom
      type={props.type}
      disabled={props.disabled}
      value={props.value}
      onChange={e => props.onChange(e.target.value)}
      defaultValue={props.defaultValue}
      ref={ref}
      maxLength={props.maxLength}
      pattern={props.pattern}
      error={props.error}
      style={props.style}
      autoComplete={props.autoComplete}
    />
    <Error>{props.error}</Error>
  </Container>
));

export default CusInput;
